import React, { useEffect } from "react";
import "./App.css";
import { SiteNav } from "./components/site-nav";
import { Routes, Route, useLocation } from "react-router-dom";
import { Home, About, Resume, Podcast, Contact, Services, Events, Resources } from "./pages";
import { ManchesterEvents } from "./pages/events";
import { Speaking } from "./components/speaking-page";
import { YouTube } from "./components/youtube-videos";
import { ScrollToTopButton } from "./components/scroll-to-top-button";
import { LeadGeneration } from "./pages/lead-generation";
import { TheGuide } from "./pages/the-guide";
import { AIMarketing } from "./pages/ai-marketing";
import { ProductDetail } from "./pages/product-detail";
import { CheckoutSuccess, CheckoutCancel } from "./pages/checkout";
import { DownloadPortal } from "./pages/download";
import { NotFound } from "./pages/not-found/not-found";

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, [location.pathname]);

  // Routes that have their own navbar component
  const routesWithOwnNav = ['/checkout/success', '/checkout/cancel', '/download'];
  const knownRoutes = [
    '/', '/home', '/about', '/services', '/resume', '/podcast',
    '/contact', '/speaking', '/youtube', '/free-resources', '/the-guide', '/download', '/events',
    '/resources', '/resources/london-tech-events', '/resources/manchester-tech-events', '/ai-drama'
  ];
  const isKnownRoute = knownRoutes.includes(location.pathname) || location.pathname.startsWith('/shop/');
  const is404 = !isKnownRoute && !routesWithOwnNav.includes(location.pathname);

  const showSiteNav = (isKnownRoute || is404) && !routesWithOwnNav.includes(location.pathname);

  return (
    <>
      {showSiteNav && <SiteNav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/speaking" element={<Speaking />} />
        <Route path="/youtube" element={<YouTube />} />
        <Route path="/free-resources" element={<LeadGeneration />} />
        <Route path="/the-guide" element={<TheGuide />} />
        <Route path="/ai-drama" element={<AIMarketing />} />
        <Route path="/events" element={<Events />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/london-tech-events" element={<Events />} />
        <Route path="/resources/manchester-tech-events" element={<ManchesterEvents />} />
        <Route path="/shop/:slug" element={<ProductDetail />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/cancel" element={<CheckoutCancel />} />
        <Route path="/download" element={<DownloadPortal />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ScrollToTopButton />
    </>
  );
}

export default App;
